export default __webpack_public_path__ + "assets/images/f628866416e22501b47b0d4bcd618559.png";